import {
  AfterViewInit,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {DialogPosition, DialogRole, MdDialog, MdDialogConfig} from '@angular/material';
import {Subject} from 'rxjs/Subject';
import {takeUntil, first} from 'rxjs/operators';
import {merge} from 'rxjs/observable/merge';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  @Input() title: string;
  @Output() close = new EventEmitter<void>();

  @Input() role: DialogRole;
  @Input() hasBackdrop: boolean;
  @Input() backdropClass: string;
  @Input() disableClose: boolean;
  @Input() width: string;
  @Input() height: string;
  @Input() position: DialogPosition;

  protected closeDialog$ = new Subject();

  @ViewChild('modal') template: TemplateRef<any>;
  @ContentChild('content') content: TemplateRef<any>;
  @ContentChild('actions') actions: TemplateRef<any>;

  private destroy$ = new Subject();

  constructor(private viewContainerRef: ViewContainerRef, private mdDialog: MdDialog) {}

  ngAfterViewInit() {
    // wrap into setTimeout to schedule it
    // issue https://github.com/angular/components/issues/5268
    setTimeout(() => {
      this.show();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  show() {
    const {viewContainerRef, role, hasBackdrop, backdropClass, disableClose, width, height, position} = this;
    const config: MdDialogConfig = {
      viewContainerRef,
      role,
      hasBackdrop,
      backdropClass,
      disableClose,
      width,
      height,
      position,
    };

    const dialogRef = this.mdDialog.open(this.template, config);

    merge(this.closeDialog$.pipe(takeUntil(this.destroy$)), this.destroy$)
      .pipe(first())
      .subscribe(() => dialogRef.close());

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.close.next());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.component.ts